import { render, staticRenderFns } from "./Meals.vue?vue&type=template&id=27289702&scoped=true"
import script from "./Meals.vue?vue&type=script&lang=js"
export * from "./Meals.vue?vue&type=script&lang=js"
import style0 from "./Meals.vue?vue&type=style&index=0&id=27289702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27289702",
  null
  
)

export default component.exports